// Initialize and add the map
function initFundPlacesMap() {
  const france = { lat: 46.603354, lng: 1.8883335 };
  const places = $('.js-map-container').data('places');
  
  // Map
  const map = new google.maps.Map(document.getElementById('fund_places_map'), {
    zoom: 5,
    center: france,
    mapTypeId: 'hybrid'
  });

  // Markers & tooltips
  let prevInfowindow = false; 
  for (let i = 0; i < places.length; i++) {
    let place = places[i];
    let lat = parseFloat(place.lat);
    let lng = parseFloat(place.lng);

    let contentString =
      '<div id="content" class="mapInfowindow">' +
      `<h1 id="firstHeading" class="mapInfowindowTitle">${place.activity}</h1>` +
      '<div id="bodyContent" class="mapInfowindowContent">' +
      `<p>${place.surface}</p>` +
      '</div>' +
      '</div>';

    let infowindow = new google.maps.InfoWindow({
      content: contentString
    });

    let marker = new google.maps.Marker({
      position: { lat: lat, lng: lng },
      map: map,
    });

    marker.addListener('click', () => {
      if (prevInfowindow ) {
        prevInfowindow.close();
      }

      prevInfowindow = infowindow;
      infowindow.open({
        anchor: marker,
        map,
        shouldFocus: false,
      });
    });
  }
}

window.initFundPlacesMap = initFundPlacesMap;